export default theme => ({
  dialog: {},
});
